import { PersonalAddressData } from 'policy-issuing/personal-details/views/physical-address-section';
import { Address } from 'policyholder/domain/policyholder';
import { geocodeByPlaceId, getLatLng } from 'react-places-autocomplete';

export const genericAddressErrorMessage =
  'The address you have entered is too generic, please enter your exact address';

export const fieldFromGooglePlace = (fieldNames: string | string[], place: google.maps.GeocoderResult) => {
  const results: string[] = [];

  const searchValues = typeof fieldNames === 'string' ? [fieldNames] : fieldNames;
  searchValues.forEach((searchValue) => {
    const found = place.address_components.find((addressComponent) => {
      return addressComponent.types.includes(searchValue);
    });
    if (found) {
      results.push(found.short_name);
    }
  });
  return results.length === 0 ? '' : results.join(' ');
};

export const addressFromGooglePlace = async (place: google.maps.GeocoderResult) => {
  const { lat, lng } = await getLatLng(place);
  const country = fieldFromGooglePlace('country', place);

  if (country === 'GB') {
    const address: Address = {
      googlePlaceId: place.place_id,
      line1: fieldFromGooglePlace(['street_number', 'route'], place),
      line2: '',
      suburb:
        fieldFromGooglePlace('administrative_area_level_2', place) ||
        fieldFromGooglePlace('administrative_area_level_1', place),
      city: fieldFromGooglePlace('postal_town', place),
      country,
      areaCode: fieldFromGooglePlace('postal_code', place),
      geoCoordinatesLatitude: lat.toString(),
      geoCoordinatesLongitude: lng.toString(),
    };

    return address;
  }

  // For ZA (South Africa) or default
  const address: Address = {
    googlePlaceId: place.place_id,
    line1: fieldFromGooglePlace(['street_number', 'route'], place),
    line2: '',
    suburb: fieldFromGooglePlace('sublocality', place),
    city: fieldFromGooglePlace('locality', place),
    areaCode: fieldFromGooglePlace('postal_code', place),
    country,
    geoCoordinatesLatitude: lat.toString(),
    geoCoordinatesLongitude: lng.toString(),
  };

  return address;
};

export const getAddressStringForPlacesDefault = (address: PersonalAddressData | undefined) => {
  return address?.googlePlaceId ? `${address.addressLine1}, ${address.suburb}, ${address.city} ` : '';
};

export const getGooglePlacesDefaultValue = async (placeId: string) => {
  const geocode = await geocodeByPlaceId(placeId);
  if (geocode.length === 1) {
    return geocode[0].formatted_address;
  }

  return '';
};

export const validateAddress = (params: { address: Address; isSuburbRequired: boolean }) => {
  const { address, isSuburbRequired } = params;
  if (
    !address.line1 ||
    !address.city ||
    !address.country ||
    !address.areaCode ||
    (isSuburbRequired && !address.suburb)
  ) {
    throw new Error(genericAddressErrorMessage);
  }
};
